import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ProductCard = ({product}) => {
    const {name,category,imageurl,price,quantity}=product;
  
    const products = useSelector((state) => state.products);
    const dispatch = useDispatch();
console.log('products', products)

  return (
    <><div className="lws-productCard">
    <img className="lws-productImage" src={imageurl}alt={name} />
    <div className="p-4 space-y-2">
      <h4 className="lws-productName">{name}</h4>
      <p className="lws-productCategory">{category}</p>
      <div className="flex items-center justify-between pb-2">
        <p className="productPrice">BDT <span className="lws-price">{price}</span></p>
        <p className="productQuantity">QTY <span className="lws-quantity">{quantity}</span></p>
      </div>
      <button className="lws-btnAddToCart" disabled={quantity <1} onClick={()=>dispatch({type:"product/addcart",payload:product})}>Add To Cart</button>
    </div>
  </div></>
  )
}

export default ProductCard